import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { SharedUiAboutThisPropertyWrapper } from 'src/common/components/infosite/shared-ui/details/about-this-property-wrapper';
import { SharedUiAmenityDescriptionWrapper } from 'src/common/components/infosite/shared-ui/details/amenity-description-wrapper';
import { SharedUiImportantInfoWrapper } from 'src/common/components/infosite/shared-ui/details/important-info-wrapper';
import { SharedUiPoliciesWrapper } from 'src/common/components/infosite/shared-ui/details/policies-wrapper';
import { SharedUiPropertyPillFiltersWrapper } from 'components/infosite/shared-ui/shared-ui-property-pill-filters';
import { SharedUiSimilarPropertiesWrapper } from 'components/infosite/shared-ui/shared-ui-similar-properties';

export const PropertyInformation: React.FC = () => (
  <>
    <SharedUiAboutThisPropertyWrapper />
    <SharedUiAmenityDescriptionWrapper />
    <SharedUiSimilarPropertiesWrapper />
    <Experiment name="LP_PDP_culdesac_display_filter_pills_to_HSR">
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <SharedUiPropertyPillFiltersWrapper />
      </ExperimentVariant>
      <ExperimentVariant bucket={2} />
    </Experiment>
    <SharedUiPoliciesWrapper />
    <SharedUiImportantInfoWrapper />
  </>
);
